module.exports = __webpack_public_path__ + "img/hero.012ae9df.jpg";